import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom';
import ModalImpressaoCupomBagagem from './ModalImpressaoCupomBagagem';
import { tipoImpressaoCupom } from '../../util/constantsUtil';
import { formatarReal } from '../../util/numberUtil';
import ReciboCupomBagagem from './ReciboCupomBagagem';
import Moment from 'react-moment';

export class ReciboBagagem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      referencias: null,
      componentRef:  React.createRef(),
      pagina: null,
      referenciasCheckeds: [],
      refComponent: React.createRef(),
      isOpenModal: false,
      tipoImpressaoCupom: tipoImpressaoCupom.normal,
      bagagemAtual: 0, // Índice da bagagem atual sendo exibida
    }
  }

   imprimir() {
      window.print();
    }

  habilitarDesabilitarReciboCupomBagagem(valor) {
    this.setState({ isOpenModal: valor })
  }

  setTipoImpressaoCupom(tipo) {
    this.setState({ tipoImpressaoCupom: tipo })
  }

  getBagagemAtual() {
    const { bagagem } = this.props;
    if (Array.isArray(bagagem)) {
      return bagagem[this.state.bagagemAtual] || bagagem[0];
    }
    return bagagem;
  }

  getTotalBagagens() {
    const { bagagem } = this.props;
    return Array.isArray(bagagem) ? bagagem.length : 1;
  }

  proximaBagagem() {
    const total = this.getTotalBagagens();
    if (this.state.bagagemAtual < total - 1) {
      this.setState({ bagagemAtual: this.state.bagagemAtual + 1 }, () => {
        this.getReferencias(this.getBagagemAtual());
      });
    }
  }

  bagagemAnterior() {
    if (this.state.bagagemAtual > 0) {
      this.setState({ bagagemAtual: this.state.bagagemAtual - 1 }, () => {
        this.getReferencias(this.getBagagemAtual());
      });
    }
  }

  componentDidMount() {
    this.setState({pagina: window})
    this.getReferencias(this.getBagagemAtual());
  }

  getReferencias(bagagem) {
    const ref = new Map();
    ref.set('PASSAGEIRO', {
      id: 'passageiro',
      nome: `Passageiro: ${bagagem.nomePassageiro}`,
      nomeParaImpressao: bagagem.nomePassageiro,
      referencia: React.createRef()
    })
    ref.set('EMPRESA', {
      id: 'empresa',
      nome: 'via empresa',
      nomeParaImpressao: 'via empresa',
      referencia: React.createRef()
    })

    if (bagagem.itensMetroCubico && bagagem.itensMetroCubico.length > 0) {
      ref.set('VOLUMES', {
        id: 'volumes',
        nome: `Etiquetas de volume (${bagagem.itensMetroCubico.length})`,
        nomeParaImpressao: 'etiquetas-volume',
        referencia: React.createRef()
      })
    }

    this.setState({
      referencias: ref,
      referenciasCheckeds: [...ref.keys()].map(it => ({
        key: it,
        checked: true
      }))
    })
  }

  marcarReferencia(key) {
    const referenciasCheckeds = [...this.state.referenciasCheckeds];
    referenciasCheckeds.forEach(it => {
      if (it.key === key) it.checked = !it.checked;
    })
    this.setState({ referenciasCheckeds })
  }

  limparMarcacaoReferenciasCheckeds() {
    const referenciasCheckeds = [...this.state.referenciasCheckeds];
    referenciasCheckeds.forEach(it => it.checked = false);
    this.setState({ referenciasCheckeds })
  }



  exibirCupom(pagina, via) {
    const bagagem = this.getBagagemAtual();
    const { empresaSelecionada } = this.props;
    return <React.Fragment>
      <div className='kloai mt-2' style={{ border: '1px solid' }}>
        {!bagagem.ativa?
            <h1 className="text-center font-bold">CANCELADA</h1>
        :''}
        <div className="invoice-title">
          <div className="row justify-content-around">
            <div className="col-md-3"><strong>{empresaSelecionada.nome}</strong></div>
            <div className="col-md-3"><strong>Emissão: <Moment format="DD/MM/YYYY">{bagagem.dataHoraRegistro}</Moment></strong></div>
            <div className="col-md-2"><strong>Via: {via}</strong></div>
            <div className="col-md-2"><strong>OS número: {bagagem.id}</strong></div>
          </div>
          <hr />
          <div className="row justify-content-around">
            <div className="col-md-6"><strong>Passageiro:</strong> {bagagem.nomePassageiro}</div>
            <div className="col-md-6"><strong>Identificador:</strong> {bagagem.codigoRastreio}</div>
          </div>
        </div>
        <hr />
        <div className="row justify-content-around">
          <div className="col-md-4">
            <strong>Vendedor:</strong> {bagagem.nomeVendedor}
          </div>
          <div className="col-md-4">
            <strong>Peso:</strong> {bagagem.peso ? `${bagagem.peso} Kg` : '0 Kg'}
          </div>
          <div className="col-md-4">
            <strong>Valor:</strong>
            {bagagem.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) || 'R$ 0,00'}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <strong>Observação:</strong> {bagagem.observacao}
          </div>
        </div>
        {bagagem.valorTipoCalculoBagagem === 'VALOR_POR_METRO_CUBICO' && bagagem.volumeTotalMetroCubico != null && (
          <div className="row">
            <div className="col-md-12">
              <strong>Cubagem total:</strong> {Number(bagagem.volumeTotalMetroCubico).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³
            </div>
          </div>
        )}
        {bagagem.itensMetroCubico && bagagem.itensMetroCubico.length > 0 && (
          <div className="row mt-2">
            <div className="col-md-12">
              <strong>Volumes:</strong>
              <table className="table table-sm table-bordered mt-1" style={{ fontSize: 13 }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Etiqueta</th>
                    <th>Descrição</th>
                    <th>C × L × A (cm)</th>
                    <th>Volume (m³)</th>
                  </tr>
                </thead>
                <tbody>
                  {bagagem.itensMetroCubico.map(it => (
                    <tr key={it.id || it.sequencia}>
                      <td>{it.sequencia}</td>
                      <td><strong>{it.sequencia}/{bagagem.reservaId}</strong></td>
                      <td>{it.descricao || '-'}</td>
                      <td>{Number(it.comprimento).toLocaleString('pt-BR')} × {Number(it.largura).toLocaleString('pt-BR')} × {Number(it.altura).toLocaleString('pt-BR')}</td>
                      <td>{Number(it.volumeUnitario).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <hr />
        <div className="row justify-content-around">
          <div className="col-md-4"><strong>Tipo de cálculo:</strong> {bagagem.descTipoCalculoBagagem}</div>
          <div className="col-md-4"><strong>Data emissão:</strong>
            <Moment format="DD/MM/YYYY">{bagagem.dataHoraRegistro}</Moment>
          </div>
          <div className="col-md-4 text-right"><strong>Página: {pagina}/1</strong></div>
        </div>
        <strong>Formas de pagamento:</strong><br />
         {this.exibirFormasPagamento()}
      </div>
    </React.Fragment>
  }

exibirBotoes() {
    const totalBagagens = this.getTotalBagagens();
    const temMultiplasBagagens = totalBagagens > 1;
    
    return (
      <React.Fragment>
        <div className='row justify-content-md-center mt-2' id='printPageButton'>
          <Link className="ml-2" to="/painel-bagagem">
            <button className='btn btn-sm btn-laranja'>Concluir</button>
          </Link>
          
          {temMultiplasBagagens && (
            <React.Fragment>
              <button 
                className="btn btn-sm btn-secondary ml-2" 
                onClick={() => this.bagagemAnterior()}
                disabled={this.state.bagagemAtual === 0}
              >
                <i className="material-icons mr-1" style={{ fontSize: '18px', verticalAlign: 'middle' }}>
                  &#xe5c4;
                </i>
                Anterior
              </button>
              
              <span className="ml-2 mr-2 align-self-center">
                {this.state.bagagemAtual + 1} de {totalBagagens}
              </span>
              
              <button 
                className="btn btn-sm btn-secondary ml-2" 
                onClick={() => this.proximaBagagem()}
                disabled={this.state.bagagemAtual === totalBagagens - 1}
              >
                Próxima
                <i className="material-icons ml-1" style={{ fontSize: '18px', verticalAlign: 'middle' }}>
                  &#xe5c8;
                </i>
              </button>
            </React.Fragment>
          )}
          
          <a className="btn  btn-sm btn-laranja ml-2" data-toggle="modal"
            data-target="#modalImpressaoCupomBagagem" onClick={() => this.habilitarDesabilitarReciboCupomBagagem(true)}>
           <i className="material-icons mr-1" style={{
              fontSize: '18px',
              verticalAlign: 'middle'
            }}>
              &#xe8ad;
            </i>
            Imprimir
          </a>
        </div>
      </React.Fragment>)
  }

  apresentarReciboCupomTermica() {
    return this.state.isOpenModal;
  }


  apresentarReciboCupomNormal() {
    return this.state.tipoImpressaoCupom === tipoImpressaoCupom.normal;
  }

   exibirFormasPagamento() {
      const bagagemAtual = this.getBagagemAtual();
      if (!bagagemAtual || !bagagemAtual.formasPagamento) {
        return <div>Nenhuma forma de pagamento</div>;
      }
      return bagagemAtual.formasPagamento.map(it => <div key={it.idFormaPagamento}><strong className='mr-2'>{it.tipo}:</strong>{formatarReal(it.valor.toString())}<br />
        {it.quantidadeParcelas > 1 ? <div><strong>Parcelas: </strong>{it.quantidadeParcelas}x<br /></div> : ''}
      </div>)
    }


  render() {
    const bagagemAtual = this.getBagagemAtual();
    if (bagagemAtual) {
      return <React.Fragment>
        <div className="grid invoice">
          {this.exibirBotoes()}
          <div ref={this.state.componentRef} className="grid-body mt-4" id='cupom-bagagem' style={{ fontSize: 16, fontWeight: 'bold' }}>
            {this.exibirCupom(1, 'Passageiro')}
            {this.exibirCupom(2, 'Empŕesa')}
          </div>
          {this.exibirBotoes()}
        </div>

        {this.apresentarReciboCupomTermica() && <div ref={this.state.refComponent} className="printer-ticket ReciboCupomBagagem">
            <ReciboCupomBagagem referencias={this.state.referencias} bagagem={bagagemAtual} empresaSelecionada={this.props.empresaSelecionada} />
        </div>}

        <ModalImpressaoCupomBagagem
          referencias={this.state.referencias}
          referenciasCheckeds={this.state.referenciasCheckeds}
          pagina={this.state.pagina}
          marcarReferencia={this.marcarReferencia.bind(this)}
          limparMarcacaoReferenciasCheckeds={this.limparMarcacaoReferenciasCheckeds.bind(this)}
          refComponent={this.state.refComponent}
          isOpenModal={this.state.isOpenModal}
          tipo={this.state.tipoImpressaoCupom}
          setTipoImpressaoCupom={this.setTipoImpressaoCupom.bind(this)}
          habilitarDesabilitarReciboCupomBagagem={this.habilitarDesabilitarReciboCupomBagagem.bind(this)} />
      </React.Fragment>
    }
    return '';
  }
}

export const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  bagagem: state.bagagem.bagagemSelecionada
});

export default withRouter(connect(mapStateToProps, {  })(ReciboBagagem));
